import React from 'react'
import { SortableTableHeader } from '../../../../../app/components/statelessDataTable/components/tableColumn'
import DisplayName from '../tableCells/locationDetails'
import Address from '../tableCells/address'
import { StyledSpan } from '../../../../../theme/Global'

const minimumWageLocationsTableColumns = ({
  sortOptions,
  eventHandlers,
  tippedEmployees
}) => {
  const columns = [
    {
      Header: () => (
        <SortableTableHeader {...{
          field: 'displayName',
          text: 'Location Name',
          sortOptions,
          eventHandlers
        }}
        />
      ),
      accessor: 'displayName',
      width: 250,
      minWidth: 0, // default
      maxWidth: 0, // default
      Cell: ({ cell }) => (
        <DisplayName {...{ cell }} />
      ),
      canSort: false
    },
    {
      Header: 'Jurisdiction Name',
      accessor: 'jurisdictionName',
      width: 250,
      minWidth: 0, // default
      maxWidth: 0, // default
      Cell: ({ cell }) => (
        <StyledSpan>
          {cell.row.original.jurisdictionName}
        </StyledSpan>
      ),
      canSort: false
    },
    {
      Header: () => (
        <SortableTableHeader {...{
          field: 'address',
          text: 'Address',
          sortOptions,
          eventHandlers
        }}
        />
      ),
      accessor: 'addressObject',
      width: 250,
      Cell: ({ cell }) => <Address {...cell.row.original} />,
      canSort: false
    },
    {
      Header: 'Minimum Wage',
      width: 180,
      accessor: 'minWage',
      Cell: ({ cell }) => <StyledSpan>{cell.row.original.minWage || ''}</StyledSpan>
    },
    {
      Header: 'Tipped Minimum Wage',
      width: 250,
      accessor: 'tippedMinWage',
      Cell: ({ cell }) => <StyledSpan>{ (cell.row.original.hasMultipleTippedWages ? 'See location details' : `${cell.row.original.tippedMinWage || ''}`) }</StyledSpan>
    }

  ]

  return (!tippedEmployees)
    ? columns.filter((column) => column.accessor !== 'tippedMinWage')
    : columns
}

export default minimumWageLocationsTableColumns
